export const hasEipTag = (item) => {
    return item.tags?.some((tag) => tag.name === 'customersegments' && tag.children?.some((child) => child.name === 'eip'));
};

export const selectDeliveryReturnsItem = (items, isEip) => {
    let selectedItem;

    if (isEip) {
        selectedItem = items?.find((item) => hasEipTag(item));

        if (!selectedItem) {
            selectedItem = items?.find((item) => !hasEipTag(item));
        }
    } else {
        selectedItem = items?.find((item) => !hasEipTag(item));

        if (!selectedItem) {
            selectedItem = items[0];
        }
    }

    return selectedItem;
};

export const extractTeaserData = (selectedItem) => {
    if (!selectedItem?.teaser) {
        return {
            deliveryText: undefined,
            returnsText: undefined,
            deliveryTextPlain: undefined,
            returnsTextPlain: undefined,
        };
    }

    const { teaserPreTitle, teaserText, teaserPreTitlePlain, teaserTextPlain } = selectedItem.teaser;

    return {
        deliveryText: teaserPreTitle,
        returnsText: teaserText,
        deliveryTextPlain: teaserPreTitlePlain,
        returnsTextPlain: teaserTextPlain,
    };
};
